<template>
    <Layout>
        <PageHeader :title="title" :items="items" /> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-phone bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                               <h5 class="mt-3">{{this.$t('phone.phone-number-search')}}</h5>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-sm-12 text-right">
                            <div class="input-group">
                                <input
                                id="search"
                                type="text"
                                class="form-control"
                                v-model="searchKey"
                                v-on:input="acceptNumber(searchKey)"
                                placeholder="628.."
                                aria-describedby="search"
                                @keyup.enter="searchPhoneTagsElastic"
                                />
                                <div class="input-group-prepend">
                                <button
                                    id="search"
                                    class="input-group-text bg-primary text-white"
                                    @click="searchPhoneTagsElastic"
                                >
                                    <i class="bx bx-search-alt search-icon"></i>
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="loading" class="row mt-5 p-5 mb-5 mx-auto">
                        <div class="text-center">
                             <div class="spinner-border text-secondary" role="status"></div>
                            <p>loading..</p>
                        </div>
                    </div>
                        <div v-if="!tokped.source && !fb.source && !userList[0] && !loading && search" class="row mt-5 p-5 mb-5 mx-auto">
                        <div class="text-center">
                            <p class="text-secondary">{{ $t('all.dnf') }}</p>
                        </div>
                    </div>
                    <div>
                    <div class="row mt-3">
                        <div class="col-sm-12" v-if="tokped.source && !loading">
                        <p><label for="validationCustom01">{{ $t('phone.source') }}</label>
                        <input type="text" class="form-control bg-light" :value="tokped.source" readonly></p>
                        <p><label for="validationCustom01">{{ $t('phone.full-name') }}</label>
                        <input type="text" class="form-control bg-light mb-1" :value="tokped.full_name" readonly></p>
                        <p><label for="validationCustom01">{{ $t('phone.email-user') }}</label>
                        <input type="text" class="form-control bg-light mb-1" :value="tokped.user_email" readonly></p>
                        <hr>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group px-3 row mb-3">
                                    <label class="col-form-label">Target Profile</label>
                                    <b-form-tags
                                        id="tags-with-dropdown"
                                        v-model="relation"
                                        no-outer-focus
                                    >
                                        <template
                                        v-slot="{ tags, disabled, removeTag }"
                                        >
                                        <ul
                                            v-if="tags.length > 0"
                                            class="list-inline d-inline-block mb-2"
                                        >
                                            <li
                                            v-for="(tag, index) in tags"
                                            :key="index"
                                            class="list-inline-item mb-2"
                                            >
                                            <b-form-tag
                                                @remove="removeTag(tag)"
                                                :title="tag"
                                                :disabled="disabled"
                                                variant="primary"
                                            >
                                                <div class="team">
                                                <a
                                                    href="javascript: void(0);"
                                                    class="team-member d-inline-block"
                                                >
                                                    <img
                                                    :src="url_image + JSON.parse(tag).image"
                                                    class="rounded-circle avatar-xs m-1"
                                                    alt
                                                    />
                                                </a>
                                                </div>
                                                {{ JSON.parse(tag).name }}
                                            </b-form-tag>
                                            </li>
                                        </ul>

                                        <b-dropdown
                                        v-if="relation.length !== 1 "
                                            size="sm"
                                            variant="outline-secondary"
                                            block
                                            menu-class="w-100"
                                        >
                                            <template #button-content>
                                            {{ $t("wizard.form.button.relation_profile") }}
                                            </template>
                                            <b-dropdown-form @submit.stop.prevent="() => {}">
                                            <b-form-group
                                                :label="
                                                $t(
                                                    'wizard.form.label.relation_profile_search'
                                                )
                                                "
                                                label-for="tag-search-input"
                                                label-cols-md="auto"
                                                class="mb-0"
                                                label-size="sm"
                                                :description="searchDesc"
                                                :disabled="disabled"
                                            >
                                                <b-form-input
                                                v-on:keyup="
                                                    searchTarget != ''
                                                    ? (show = true)
                                                    : (show = false)
                                                "
                                                v-model="searchTarget"
                                                id="tag-search-input"
                                                type="search"
                                                size="sm"
                                                autocomplete="off"
                                                ></b-form-input>
                                            </b-form-group>
                                            </b-dropdown-form>
                                            <b-dropdown-divider>
                                            
                                            </b-dropdown-divider>

                                            <b-dropdown-item-button
                                            v-show="show"
                                            v-for="(option, index) in availableOptions"
                                            :key="index"
                                            @click="onOptionClick(option)"
                                            >
                                            {{ option.name }}
                                            </b-dropdown-item-button>
                                            <b-dropdown-text
                                            v-if="availableOptions.length === 0"
                                            >
                                            {{ $t("wizard.form.validation.not_match2") }}
                                            </b-dropdown-text>
                                        </b-dropdown>
                                        </template>
                                    </b-form-tags>
                                    <div class="mt-4">
                                            <button class="xbadge btn btn-secondary  mr-1 mb-1 px-2 btn-sm text-white rounded"  @click="clearDataTokped"> {{ $t("phone.clear") }}  </button><button class="xbadge rounded btn btn-success  mr-1 mb-1 px-2 btn-sm text-white" :disabled="relation.length !== 1 "  @click="AddTargetTag(tokped.full_name, tokped.user_email)">{{ $t("button.save-tag-name") }} </button>  
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12" v-if="fb.source && !loading">
                            <p><label for="validationCustom01">{{ $t('phone.source') }}</label>
                            <input type="text" class="form-control bg-light" :value="fb.source" readonly></p>
                            <p><label for="validationCustom01">{{ $t('phone.full-name') }}</label>
                            <input type="text" class="form-control bg-light mb-1" :value="fb.firstName" readonly></p>
                            <p><label for="validationCustom01">{{ $t('phone.last-name') }}</label>
                            <input type="text" class="form-control bg-light mb-1" :value="fb.lastName" readonly></p>
                            <hr>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group px-3 row mb-3">
                                    <label class="col-form-label">Target Profile</label>
                                    <b-form-tags
                                        id="tags-with-dropdown"
                                        v-model="relation"
                                        no-outer-focus
                                    >
                                        <template
                                        v-slot="{ tags, disabled, removeTag }"
                                        >
                                        <ul
                                            v-if="tags.length > 0"
                                            class="list-inline d-inline-block mb-2"
                                        >
                                            <li
                                            v-for="(tag, index) in tags"
                                            :key="index"
                                            class="list-inline-item mb-2"
                                            >
                                            <b-form-tag
                                                @remove="removeTag(tag)"
                                                :title="tag"
                                                :disabled="disabled"
                                                variant="primary"
                                            >
                                                <div class="team">
                                                <a
                                                    href="javascript: void(0);"
                                                    class="team-member d-inline-block"
                                                >
                                                    <img
                                                    :src="url_image + JSON.parse(tag).image"
                                                    class="rounded-circle avatar-xs m-1"
                                                    alt
                                                    />
                                                </a>
                                                </div>
                                                {{ JSON.parse(tag).name }}
                                            </b-form-tag>
                                            </li>
                                        </ul>

                                        <b-dropdown
                                        v-if="relation.length !== 1 "
                                            size="sm"
                                            variant="outline-secondary"
                                            block
                                            menu-class="w-100"
                                        >
                                            <template #button-content>
                                            {{ $t("wizard.form.button.relation_profile") }}
                                            </template>
                                            <b-dropdown-form @submit.stop.prevent="() => {}">
                                            <b-form-group
                                                :label="
                                                $t(
                                                    'wizard.form.label.relation_profile_search'
                                                )
                                                "
                                                label-for="tag-search-input"
                                                label-cols-md="auto"
                                                class="mb-0"
                                                label-size="sm"
                                                :description="searchDesc"
                                                :disabled="disabled"
                                            >
                                                <b-form-input
                                                v-on:keyup="
                                                    searchTarget != ''
                                                    ? (show = true)
                                                    : (show = false)
                                                "
                                                v-model="searchTarget"
                                                id="tag-search-input"
                                                type="search"
                                                size="sm"
                                                autocomplete="off"
                                                ></b-form-input>
                                            </b-form-group>
                                            </b-dropdown-form>
                                            <b-dropdown-divider>
                                            
                                            </b-dropdown-divider>

                                            <b-dropdown-item-button
                                            v-show="show"
                                            v-for="(option, index) in availableOptions"
                                            :key="index"
                                            @click="onOptionClick(option)"
                                            >
                                            {{ option.name }}
                                            </b-dropdown-item-button>
                                            <b-dropdown-text
                                            v-if="availableOptions.length === 0"
                                            >
                                            {{ $t("wizard.form.validation.not_match2") }}
                                            </b-dropdown-text>
                                        </b-dropdown>
                                        </template>
                                    </b-form-tags>
                                    <div class="mt-4">
                                            <button class="xbadge btn btn-secondary  mr-1 mb-1 px-2 btn-sm text-white rounded"  @click="clearDataFB"> {{ $t("phone.clear") }}  </button><button class="xbadge btn btn-success  mr-1 mb-1 px-2 btn-sm text-white rounded" :disabled="relation.length !== 1 "  @click="AddTargetTagFB(fb.firstName, fb.lastName)">{{ $t("button.save-tag-name") }} </button>  
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div>           
                        </div>
                    </div>
                    <div class="row mt-3" v-if="userList && !loading">
                        <div class="col-sm-12" >
                            <hr v-if="tokped.full_name || fb.lastName || fb.firstName">
                            <h5  class="mb-3">Telegram </h5>
                        </div>
                        <div class="col-sm-6">
                            <div v-for="(list, index) in userList" :key="index">
                                <p v-if="list.username"><label for="validationCustom01">{{$t('overview.table.all.first_name')}}</label>
                                <input type="text" class="form-control bg-light mb-1" :value="list.username" readonly></p>
                                <p v-if="list.first_name"><label for="validationCustom01">{{$t('overview.table.all.first_name')}}</label>
                                <input type="text" class="form-control bg-light mb-1" :value="list.first_name" readonly></p>    
                                <p v-if="list.last_name"><label for="validationCustom01">{{$t('overview.table.all.last_name')}}</label>
                                <input type="text" class="form-control bg-light mb-1" :value="list.last_name" readonly></p>
                                <p v-if="list.phone"><label for="validationCustom01">{{$t('overview.table.all.phone')}}</label>
                                <input type="text" class="form-control bg-light mb-1" :value="list.phone" readonly></p>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label for="validationCustom01">{{$t('overview.table.all.list-group')}}</label>
                            <div v-if="loadingGrup" class="mt-4 mx-auto p-5">
                        <div class="text-center">
                                <div class="spinner-border text-secondary" role="status" v-if="loadingGrup">
                            </div>
                            </div>
                            </div>
                            <div>
                                <span v-for="(list, index) in x.hits" :key="index">
                                <router-link to="#" class="xbadge btn btn-light mr-1 mb-1 btn-sm text-secondary rounded">{{list._id}} </router-link>   </span>
                            </div>
                            <hr>
                            <div class="form-group px-3 row mb-3">
                                    <label class="col-form-label">Target Profile</label>
                                    <b-form-tags
                                        id="tags-with-dropdown"
                                        v-model="relation"
                                        no-outer-focus
                                    >
                                        <template
                                        v-slot="{ tags, disabled, removeTag }"
                                        >
                                        <ul
                                            v-if="tags.length > 0"
                                            class="list-inline d-inline-block mb-2"
                                        >
                                            <li
                                            v-for="(tag, index) in tags"
                                            :key="index"
                                            class="list-inline-item mb-2"
                                            >
                                            <b-form-tag
                                                @remove="removeTag(tag)"
                                                :title="tag"
                                                :disabled="disabled"
                                                variant="primary"
                                            >
                                                <div class="team">
                                                <a
                                                    href="javascript: void(0);"
                                                    class="team-member d-inline-block"
                                                >
                                                    <img
                                                    :src="url_image + JSON.parse(tag).image"
                                                    class="rounded-circle avatar-xs m-1"
                                                    alt
                                                    />
                                                </a>
                                                </div>
                                                {{ JSON.parse(tag).name }}
                                            </b-form-tag>
                                            </li>
                                        </ul>

                                        <b-dropdown
                                           v-if="relation.length !== 1 "
                                            size="sm"
                                            variant="outline-secondary"
                                            block
                                            menu-class="w-100"
                                        >
                                            <template #button-content>
                                            {{ $t("wizard.form.button.relation_profile") }}
                                            </template>
                                            <b-dropdown-form @submit.stop.prevent="() => {}">
                                            <b-form-group
                                                :label="
                                                $t(
                                                    'wizard.form.label.relation_profile_search'
                                                )
                                                "
                                                label-for="tag-search-input"
                                                label-cols-md="auto"
                                                class="mb-0"
                                                label-size="sm"
                                                :description="searchDesc"
                                                :disabled="disabled"
                                            >
                                                <b-form-input
                                                v-on:keyup="
                                                    searchTarget != ''
                                                    ? (show = true)
                                                    : (show = false)
                                                "
                                                v-model="searchTarget"
                                                id="tag-search-input"
                                                type="search"
                                                size="sm"
                                                autocomplete="off"
                                                ></b-form-input>
                                            </b-form-group>
                                            </b-dropdown-form>
                                            <b-dropdown-divider>
                                            
                                            </b-dropdown-divider>

                                            <b-dropdown-item-button
                                            v-show="show"
                                            v-for="(option, index) in availableOptions"
                                            :key="index"
                                            @click="onOptionClick(option)"
                                            >
                                            {{ option.name }}
                                            </b-dropdown-item-button>
                                            <b-dropdown-text
                                            v-if="availableOptions.length === 0"
                                            >
                                            {{ $t("wizard.form.validation.not_match2") }}
                                            </b-dropdown-text>
                                        </b-dropdown>
                                        </template>
                                    </b-form-tags>
                            </div>
                            <div class="text-right">
                                <button class="xbadge btn btn-secondary  mr-1 mb-1 px-2 btn-sm text-white rounded"  @click="clearDataTele"> {{ $t("phone.clear") }}</button><button class="xbadge btn btn-success  mr-1 mb-1 px-2 btn-sm text-white rounded" :disabled="relation.length !== 1 "  @click="AddTargetTelegram">{{ $t("phone.save-tele") }}</button>  
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import PhoneService from "@/helpers/phone.service.js";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import GroupService from "@/helpers/group.service";
import PreferenceService from "@/helpers/preference.service.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Tools Instagram",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('phone.phone-number-search'),
                active: true
                }
            ],
            url_image:process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
            loadingGrup:false,
            searchTarget:"",
            x:{ "total": { "value": 0, "relation": "eq" }, "hits": []},
            relation:[],
            options: [],
            userList:"",
            elastic:"",
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            loadinglist:false,
            search: false,
            searchKey: "",
            SearchResult: "",
            tokped:[],
            fb:[],
            dnf:false,
            dnfp:false,
            is_spam:"",
            search:false,
            title: this.$t('phone.phone-tools')
        }
    },
    computed:{
        criteria() {
        return this.searchTarget.trim().toLowerCase();
        },
        
        availableOptions() {
        const criteria = this.criteria;
        let element = [];
        try {
            for (let i = 0; i < this.relation.length; i++) {
            element.push(JSON.parse(this.relation[i]).id);
            }
        } catch (e) {
            element = [];
        }
        const options = this.options.filter(
            (opt) => element.indexOf(opt.id) === -1
        );
        this.show = false;
        if (criteria) {
            this.show = true;
            return options.filter((opt) =>
            opt.name.toLowerCase().includes(criteria)
            );
        }
        return options;
        },
        searchDesc() {
        if (this.criteria && this.availableOptions.length === 0) {
            return this.$t("wizard.form.validation.not_match1");
        }
        return "";
        },
        validFormat() {
        if (this.validformat != null) {
            if (this.validformat) {
            return "is-valid";
            } else {
            return "is-invalid";
            }
        }
        },
    },
    methods:{
        getPreferences(){
                PreferenceService.getAllElastic()
                .then((response) => {
                    this.elastic = response.data.data[0].ip_address;
                })
                .catch((err) => {
                    console.log(err);
                });
         },
        searchPhoneTagsElastic() {
            if (this.searchKey != "") {
                this.search = true;    
                this.loading = true;
                this.tokped = [];
                var data = {
                "size": 1,
                "query": {
                "match": {
                "phone": this.searchKey
                }
            }
            };
                PhoneService.searchPhoneTokped(this.elastic, data)
                .then((response) => {
                    const res = response.data.hits;
                    const data = {
                        "source" : "E-commerce Dataset",
                        "full_name" : res.hits[0]._source.full_name,
                        "user_email" :res.hits[0]._source.user_email,
                    }
                    this.tokped = data;
                    this.searchPhoneTagsElasticFb();
                })
                .catch((err) => {
                    console.log(err);
                    this.searchPhoneTagsElasticFb();
                });
            }
        },

        searchPhoneTagsElasticFb() {
            var number =  this.searchKey.substr(2, 20);
            const data = {
                "size": 1,
                "query": {
                    "match": {
                    "phone": number 
                    }
                }
            };
            if (this.searchKey != "") {
                this.fb = []
                PhoneService.searchPhoneFb(this.elastic, data)
                .then((response) => {
                    const res = response.data.hits;
                    const data = {
                            "source" : "Social Media Dataset",
                            "firstName" : res.hits[0]._source.firstName,
                            "lastName" : res.hits[0]._source.lastName,
                            }
                    this.fb = data;
                    this.SearchPhoneTele()
                })
                .catch((err) => {
                    console.log(err);
                    this.SearchPhoneTele()
                });
            }
        },
                
        SearchPhoneTele(){
        const data = {
            "size": 1000,
            "query": {
                "match": {
                "listmember.phone.keyword": this.searchKey
                }
            } 
        };
        // console.log(data);
        if (this.searchKey != "") {
            this.loading = true;
            this.x = [];
            this.userList="";
            GroupService.SearchGroupByPhone(this.elastic, data)
            .then((response) => {
                this.x = response.data.hits;
                var username =  response.data.hits.hits[0]._id;
                this.getUserTele(username)
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;  
            });
        }
        },

        getUserTele(username){
        const data = {
            "size": 1000,
            "query": {
                "match": {
                "username": username
                }
            } 
        };
        // console.log(data);
        if (this.searchKey != "") {
            this.userList = []
            GroupService.SearchListMemberByGroup(this.elastic, data)
            .then((response) => {

                var dataMember = response.data.hits.hits[0]._source.listmember;              
                    dataMember.forEach(val => {
                        const data = {    
                        "user_id" : val.user_id,
                        "username" : val.username,
                        "first_name" : val.first_name,
                        "last_name" : val.last_name,
                        "phone" : val.phone,
                        }
                        if(data.phone == this.searchKey){
                        this.userList.push(data);
                        } 
                        this.loading = false;  
                });
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;  
            });
        }
        },

        AddTargetTelegram(){
        var data = {
            "id_target":  JSON.parse(this.relation).id,
            "account" : this.userList[0].username,
            "user_id" : this.userList[0].user_id,
            "first_name" : this.userList[0].first_name,
            "last_name" : this.userList[0].last_name,
            "phone" : this.userList[0].phone,
            "group_list" : JSON.stringify(this.x.hits),
        }
            SocmedService.createTelegram(data)
            .then( response => {
                Vue.swal({
                    position: "top-end",
                    icon: "success",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                });
            
             this.$router.push({ name:'project-overview', params: { id: JSON.parse(this.relation).id }})
             this.clearDataFB();
             this.clearDataTele();
             this.clearDataTokped();
            })
            .catch(err => {
                console.log(err);
            });
        },

        listProfile() {
            TargetService.getTargetBy()
            .then((response) => {
                response.data.data.forEach((val) => {
                const opt = {
                    name: val.title,
                    id: val.id_target,
                    image: val.image_project,
                };
                this.options.push(opt);
                });
            })
            .catch((err) => {
                console.log(err);
            });
        },

        AddTargetTag(tag, email){
            const data = {
                'id_target': JSON.parse(this.relation).id,
                'name' : tag,
                'surname' : "",
                'phone_number' : this.searchKey,
                'country_code' : "",
                'display_name' : "",
                'profile_image' : "",
                'email' : email,
                'is_spam' : "",
                'remain_count' : 1,
                'tags' : '["'+tag+'"]',
            }
            console.log(data);
            PhoneService.add_contact(data)
            .then(response => {
                console.log(response.data);
                Vue.swal({
                    position: "top-end",
                    icon: "success",
                    title: "Success Add To Project",
                    showConfirmButton: false,
                    timer: 2000
                });
                this.$router.push({ name:'project-overview', params: { id: JSON.parse(this.relation).id }})
            })
            .catch(err => {
                console.log(err);
            })
        },

        AddTargetTagFB(fn, ln){
            const data = {
                'id_target': JSON.parse(this.relation).id,
                'name' : fn + ln,
                'surname' : "",
                'phone_number' : this.searchKey,
                'country_code' : "",
                'display_name' : "",
                'profile_image' : "",
                'email' : "",
                'is_spam' : "",
                'remain_count' : 1,
                'tags' : '["'+fn+'"]',
            }
            console.log(data);
            PhoneService.add_contact(data)
            .then(response => {
                console.log(response.data);
                Vue.swal({
                    position: "top-end",
                    icon: "success",
                    title: "Success Add To Project",
                    showConfirmButton: false,
                    timer: 2000
                });
                this.$router.push({ name:'project-overview', params: { id: JSON.parse(this.relation).id }})
            })
            .catch(err => {
                console.log(err);
            })
        },

        onOptionClick(option) {
        // console.log(option)
        // this.relation.id = option.id;
        // this.relation.name = option.name;
        // this.relation.image = option.image;
            this.relation.push({
            name: option.name,
            id: option.id,
            image: option.image,
        });
        this.show = false;
        this.search = "";
        },

        clearDataTele(){
            this.searchTarget = "";
            this.searchResult= [];
            this.x = [{ "total": { "value": 0, "relation": "eq" }, "hits": [ ] }];
            this.relation = "",
            this.userList = "",
            this.search = false;
        },

        clearDataTokped(){
            this.searchTarget = "";
            this.searchResult= [];
            this.x = [{ "total": { "value": 0, "relation": "eq" }, "hits": [ ] }];
            this.relation = "",
            this.tokped = [];
            this.search = false;
        },
        
        clearDataFB(){
            this.searchTarget = "";
            this.searchResult= [];
            this.x = [{ "total": { "value": 0, "relation": "eq" }, "hits": [ ] }];
            this.relation = "",
            this.fb = [];
            this.search = false;
        },


        formatDate(value){
            return moment(value).format("dddd, YYYY-MM-DD hh:mm");
        },

        acceptNumber(value) {
        let x = value[0];
        if(x == 0){
          let hasil = x.replace('0', '62');
          let number = value.slice(1,15)
          return this.searchKey = hasil+number;
        } 
       }
    },
    beforeMount() {
    this.listProfile();
  },
  mounted(){
    this.getPreferences();
    this.availableOptions;
    this.totalRows = this.items.length;
  }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>